import { h, render } from 'vue';
import Toast from './Toast.vue';

const mount = (component, { props, children, element, app } = {}) => {
  let el = element ? element : document.createElement('div');
  let vNode = h(component, props, children);
  if (app && app._context) vNode.appContext = app._context;

  render(vNode, el);

  const destroy = () => {
    if (el) render(null, el);
    el = null;
    vNode = null;
  };

  return { vNode, destroy, el };
};

console.log(mount);

// const umount = (el) => {
//   if (typeof el.remove !== 'undefined') {
//     el.remove();
//   } else {
//     el.parentNode.removeChild(el);
//   }
// };

const instances = [];
const div = document.createElement('div');
div.setAttribute('class', 'toast');
document.body.appendChild(div);
const toast = (options) => {
  // if (Vue.prototype.$isServer) return;
  const o = typeof options === 'string' ? { message: options } : options;

  const component = mount(Toast, { props: { isShow: true, type: 'msg', duration: 2000, ...o } });
  console.log(o);
  console.log(component);

  document.querySelector('body').appendChild(component.el);
  instances.push(component);
  /* eslint-disable */
  return component;
};
toast.loading = function loading(message, options = {}) {
  return toast({ type: 'loading', duration: 0, message, ...options });
};
toast.info = function warning(message, options = {}) {
  return toast({ type: 'msg', message, ...options });
};

toast.warning = function warning(message, options = {}) {
  return toast({ type: 'warning', message, ...options });
};

toast.success = function success(message, options = {}) {
  return toast({ type: 'success', message, ...options });
};

toast.error = function error(message, options = {}) {
  return toast({ type: 'error', message, ...options });
};
toast.fail = function fail(message, options = {}) {
  return toast({ type: 'fail', message, ...options });
};

toast.clear = function clear() {
  instances.forEach((instance) => {
    instance.destroy();
  });
};

export default toast;
